import * as React from 'react'

import { Button, type IllustrationType } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  description: string
  confirmText?: string
  illustration?: IllustrationType
  disableConfirm?: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmationModal: React.FC<Props> = ({
  title,
  description,
  confirmText,
  illustration,
  disableConfirm,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      illustration={illustration}
      title={title}
      onClose={onCancel}
      description={description}
      footer={
        <>
          <Button onClick={onCancel} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onConfirm} type="negative" disabled={disableConfirm}>
            {confirmText || i18n.t('common.confirm')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default observer(ConfirmationModal)
